import SectionTitle from '../../common/SectionTitle'

import './_LocationSection.scss'

import mapMark from '../../../assets/images/icons/location.svg'
import callcenter from '../../../assets/images/icons/callcenter.svg'

const LocationSection = () => {
  return (
    <div className='LocationSection' id='location'>
      <div className='container'>
        <SectionTitle
          title='Location'
          text='Where we can meet you in person'
          sm
        />
      </div>
        <div className='location-main'>
          <div className='container center-y'>
            <div className='gradient-border'>
              <div className='gradient-border-content location-info'>
                <div className='location-info-item'>
                  <div className='icon-box'>
                    <img src={mapMark} alt='' className='icon' />
                  </div>
                  <p className='text'>3600 ROUTE 66 STE 150 NEPTUNE, NJ 07753, USA</p>
                </div>
                <div className='location-info-item'>
                  <div className='icon-box'>
                    <img src={callcenter} alt='' className='icon' />
                  </div>
                  <p className='text'>+1 718-800-0000</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}


export default LocationSection
